import React, { useState } from "react";
import ImageWithBasePath from "../../../core/img/imagewithbasebath";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { setUserDetail } from "../../../core/redux/action";
import { SuccessToaster } from "../../components/toaster/Toaster";
import { emailRegex } from "../../../utils";
import { Spinner } from "react-bootstrap";
import InputField from "../../components/Input";
import AuthServices from "../../../services/Auth";
import dayjs from "dayjs";
import Storage from "../../../utils/Storage";
import { environments } from "../../../core/json/environments";
import SelectField from "../../components/Select";

const Signin = () => {

  const dispatch = useDispatch();
  const { setStorageItem } = Storage();

  const { register, handleSubmit, formState: { errors } } = useForm();
  const [loading, setLoading] = useState(false);
  const [inputError, setInputError] = useState(false);

  // *For Environment
  const [selectedEnvironment, setSelectedEnvironment] = useState(null);

  // *For Password Visibility Toggle
  const [isPasswordVisible, setPasswordVisible] = useState(false);

  const togglePasswordVisibility = () => {
    setPasswordVisible((prevState) => !prevState);
  };

  // *For Login
  const login = async (formData) => {
    setLoading(true)
    try {
      let obj = {
        email: formData?.email,
        password: formData?.password,
        environment: selectedEnvironment?.id,
      }
      const { data, message } = await AuthServices.login(obj)
      setStorageItem('token', data?.access_token)
      dispatch(setUserDetail(data))
      SuccessToaster(message)
    } catch (error) {
      setInputError(true)
      console.log('login => error:', error)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="main-wrapper">
      <div className="account-content">
        <div className="login-wrapper login-new">
          <div className="container">
            <div className="login-content user-login">
              <div className="login-logo">
                <ImageWithBasePath src="assets/img/logo-white.jpeg" alt="img" className="mb-2" />
              </div>
              <form onSubmit={handleSubmit(login)}>
                <div className="login-userset">
                  <div className="login-userheading">
                    <h3>Sign In</h3>
                    <h4>
                      Access the Digital Invoizer using your email and password.
                    </h4>
                  </div>
                  <div className="add-product mb-3">
                    <SelectField
                      label={"Environment"}
                      options={environments}
                      selected={selectedEnvironment}
                      onSelect={(value) => setSelectedEnvironment(value)}
                      error={errors?.environment?.message}
                      register={register("environment", {
                        required: 'Please select environment.'
                      })}
                    />
                  </div>
                  <div className="add-product mb-3">
                    <InputField
                      label="Email Address"
                      type="email"
                      endAdornment={
                        <ImageWithBasePath
                          src="assets/img/icons/mail.svg"
                          alt="img"
                        />
                      }
                      error={errors?.email?.message || inputError}
                      register={register("email", {
                        required: 'Please enter your email.',
                        pattern: {
                          value: emailRegex,
                          message: 'Please enter a valid email.',
                        }
                      })}
                    />
                  </div>
                  <div className="add-product mb-3">
                    <InputField
                      label="Password"
                      type={isPasswordVisible ? "text" : "password"}
                      endAdornment={
                        <span
                          className={`fas toggle-password ${isPasswordVisible ? "fa-eye" : "fa-eye-slash"
                            }`}
                          onClick={togglePasswordVisibility}
                        ></span>
                      }
                      error={errors?.password?.message ? errors?.password?.message : inputError && 'You have entered an invalid email or password.'}
                      register={register("password", {
                        required: 'Please enter the password.',
                      })}
                    />
                  </div>
                  <div className="form-login">
                    <button
                      className="btn btn-login"
                      type="submit"
                      disabled={loading}
                    >
                      {loading &&
                        <Spinner
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                          className="me-2"
                        />
                      }
                      Sign In
                    </button>
                  </div>
                </div>
              </form>
            </div>
            <div className="my-4 d-flex justify-content-center align-items-center copyright-text">
              <p>Copyright © {dayjs().format('YYYY')} Slynx Technologies. All rights reserved</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Signin;
